import * as types from './types';
import _ from 'lodash';
import { POSLetterTypeEnum } from '../../helpers/helpers';

const INITIAL_STATE = {
  loading: null,
  error: null,
  site: null,
  grade: null,
  grades: [],
  badEmailLetterHistoryIds: [],
  badStudentEmailsHistIds: [],
  badTeacherEmailsHistIds: [],
  badLowBalanceEmailsHistIds: [],
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.LETTERS_GET_GRADES:
      return {
        ...state,
        grades: payload,
      };

    case types.LETTERS_ERROR:
      const errors = _.get(payload, 'data.Errors', []);
      return {
        ...state,
        error: errors,
      };

    case types.LETTERS_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case types.LETTERS_GET_BAD_EMAILS:
      var sLetterHistoryIds = payload
        .filter(f => f.LetterType === POSLetterTypeEnum.Student.toString())
        .map(m => m.Id);
      var tLetterHistoryIds = payload
        .filter(f => f.LetterType === POSLetterTypeEnum.Teacher.toString())
        .map(m => m.Id);
      var lLetterHistoryIds = payload
        .filter(f => f.LetterType === POSLetterTypeEnum.LowBalance.toString())
        .map(m => m.Id);
      return {
        ...state,
        badStudentEmailsHistIds: sLetterHistoryIds,
        badTeacherEmailsHistIds: tLetterHistoryIds,
        badLowBalanceEmailsHistIds: lLetterHistoryIds,
      };

    case types.LETTERS_CLEAR_BAD_EMAILS_STUDENT:
      return {
        ...state,
        badStudentEmailsHistIds: payload,
      };
    case types.LETTERS_CLEAR_BAD_EMAILS_TEACHER:
      return {
        ...state,
        badTeacherEmailsHistIds: payload,
      };
    case types.LETTERS_CLEAR_BAD_EMAILS_LOWBALANCE:
      return {
        ...state,
        badLowBalanceEmailsHistIds: payload,
      };
    case types.LETTERS_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/letters/state/letters/reducer.js